import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useLanguage } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Newsletter from './components/Newsletter';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Booking from './components/Booking';
import Dashboard from './pages/Dashboard';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import CancelAppointment from './pages/CancelAppointment';
import ConfirmCancellation from './pages/ConfirmCancellation';
import RescheduleAppointment from './pages/RescheduleAppointment';
import ConfirmReschedule from './pages/ConfirmReschedule';
import RescheduleNewDate from './pages/RescheduleNewDate';

// Scroll restoration component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Section component to handle scrolling
const Section: React.FC<{ component: React.ComponentType<any> }> = ({ component: Component }) => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    const element = document.getElementById(pathname.slice(1));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [pathname]);

  return <Component />;
};

function App() {
  const { language, setLanguage } = useLanguage();

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen">
        <Navbar language={language} setLanguage={setLanguage} />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <Services language={language} />
              <About language={language} />
              <Testimonials language={language} />
              <Pricing language={language} />
              <FAQ language={language} />
              <Newsletter language={language} />
              <Contact language={language} />
            </>
          } />
          <Route path="/services" element={<Section component={() => <Services language={language} />} />} />
          <Route path="/about" element={<Section component={() => <About language={language} />} />} />
          <Route path="/testimonials" element={<Section component={() => <Testimonials language={language} />} />} />
          <Route path="/pricing" element={<Section component={() => <Pricing language={language} />} />} />
          <Route path="/faq" element={<Section component={() => <FAQ language={language} />} />} />
          <Route path="/contact" element={<Section component={() => <Contact language={language} />} />} />
          <Route path="/book" element={<Booking language={language} />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/cancel-appointment" element={<CancelAppointment />} />
          <Route path="/confirm-cancellation" element={<ConfirmCancellation />} />
          <Route path="/reschedule-appointment" element={<RescheduleAppointment />} />
          <Route path="/confirm-reschedule" element={<ConfirmReschedule />} />
          <Route path="/reschedule-new-date" element={<RescheduleNewDate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer language={language} />
      </div>
    </Router>
  );
}

export default App;